import { render, staticRenderFns } from "./Movimenti_Strumento.vue?vue&type=template&id=096cc289&"
import script from "./Movimenti_Strumento.vue?vue&type=script&lang=js&"
export * from "./Movimenti_Strumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports